<script lang="ts">
    import {_} from 'svelte-i18n'
    import {Role} from './types';
    import Menu from '@smui/menu';
    import List, {Item, Text} from '@smui/list';
    import Button, {Label} from '@smui/button';
    import {Icon} from '@smui/icon-button';
    import {
        currentConversation,
        myActiveConversation,
        myNotFinishedConversation,
        mySession,
        newConversations,
        paths,
        userService,
        walker
    } from './services';
    import {hasAnyRole} from './service/util';
    import NewConversationNotice from './NewConversationNotice.svelte';
    import OperatorName from './OperatorName.svelte';
    import SoundsModeRotatorButton from './SoundsModeRotatorButton.svelte';
    import ActiveSessionsIndicator from './ActiveSessionsIndicator.svelte';
    import PendingConversationsCount from './PendingConversationsCount.svelte';
    import {get} from 'svelte/store';

    let menu: any;

    async function editUserPassword() {
        await userService.editMySessionUserPassword();
    }

    async function logout() {
        await mySession.logout();
        await walker.goTo(get(paths).home);
    }
</script>

<div class="mdc-top-app-bar smui-top-app-bar--static" style="z-index: 50;">
    <div class="mdc-top-app-bar__row">
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start header-title sm-hide">
            <a href={$paths.home} class="mdc-top-app-bar__title mdc-theme--primary">{$_('commons.PageTitle')}</a>
        </section>

        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
            {#if $myActiveConversation !== null && (!$currentConversation || $currentConversation.id !== $myActiveConversation.id)}
				<span class="header-info">
					<a href={$paths.conversation($myActiveConversation)}>{$_('chat.BackToChat')}</a>
				</span>
            {/if}

            {#if $newConversations.size > 0}
				<span class="header-info" style="display: flex; align-items: center;">
					<NewConversationNotice />
				</span>
            {:else}
				<span class="header-info">
					<PendingConversationsCount />
				</span>
            {/if}
        </section>


        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">

            <ActiveSessionsIndicator />

            <SoundsModeRotatorButton />

            {#if hasAnyRole($mySession, Role.OPERATOR, Role.INTERVISOR, Role.ADMIN)}
                <div>
                    <Button on:click={() => menu.setOpen(true)} variant="unelevated">
                        <OperatorName session={$mySession} />
                    </Button>
                    <Menu bind:this={menu}>
                        <List>
                            <Item on:SMUI:action={() => editUserPassword()}><Text>{$_('user.auth.ChangePassword')}</Text></Item>
                        </List>
                    </Menu>
                </div>
                <Button on:click={logout} variant="unelevated">
					<span class="xs-show">
						<Icon class="material-icons">logout</Icon>
					</span>
                    <Label class="xs-hide">{$_('user.auth.Logout')}</Label>
                </Button>
            {/if}
            {#if $mySession.roles.includes(Role.CLIENT)}
                {#if $myNotFinishedConversation}
                    <span class="mdc-top-app-bar__title" style="margin-right: 10px;">{$mySession.username}</span>
                {/if}
                <Button on:click={logout} variant="unelevated" color="secondary"><Label>{$_('user.session.Leave')}</Label></Button>
            {/if}
        </section>
    </div>
</div>

<style lang="scss">
  @media (max-width: 599px) {
    .header-title {
      display: none;
    }
  }
</style>